// src/components/HeapAnalytics.js
import { useEffect } from 'react';

const HeapAnalytics = () => {
  useEffect(() => {
    const win = /** @type {any} */ (window);

    // Only load in production
    if (process.env.NODE_ENV === 'production') {
      // Initialize Heap
      win.heapReadyCb = win.heapReadyCb || [];
      win.heap = win.heap || [];
      
      win.heap.load = function(e,t) {
        win.heap.envId = e;
        win.heap.clientConfig = t = t || {};
        win.heap.clientConfig.shouldFetchServerConfig = !1;
        
        var a = document.createElement("script");
        a.type = "text/javascript";
        a.async = !0;
        a.src = "https://cdn.us.heap-api.com/config/" + e + "/heap_config.js";
        
        var r = document.getElementsByTagName("script")[0];
        r.parentNode.insertBefore(a, r);
        
        var n = ["init","startTracking","stopTracking","track","resetIdentity","identify","identifyHashed","getSessionId","getUserId","getIdentity","addUserProperties","addEventProperties","removeEventProperty","clearEventProperties","addAccountProperties","addAdapter","addTransformer","addTransformerFn","onReady","addPageviewProperties","removePageviewProperty","clearPageviewProperties","trackPageview"];
        
        var i = function(e) {
          return function() {
            var t = Array.prototype.slice.call(arguments, 0);
            win.heapReadyCb.push({
              name: e,
              fn: function() {
                win.heap[e] && win.heap[e].apply(win.heap, t);
              }
            });
          };
        };
        
        for (var p = 0; p < n.length; p++) {
          win.heap[n[p]] = i(n[p]);
        }
      };
      
      win.heap.load('1995618801');
    } else {
      // Mock function for development
      win.heap = {
        track: function() {
          console.log('Heap track (development):', ...arguments);
        },
        identify: function() {
          console.log('Heap identify (development):', ...arguments);
        },
        addUserProperties: function() {
          console.log('Heap addUserProperties (development):', ...arguments);
        }
      };
    }
  }, []);

  return null;
};

export default HeapAnalytics;